import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ContentChild,
  ContentChildren,
  InjectionToken,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatCardModule} from '@angular/material/card';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule, Sort} from '@angular/material/sort';
import {MatColumnDef, MatHeaderRowDef, MatRowDef, MatTable, MatTableDataSource, MatTableModule,} from '@angular/material/table';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {TableService} from './table.service';
import {Observable, Subscription} from 'rxjs';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import {
  TableContextMenuTriggerDirective,
  TableMenuDirective,
} from './table.directive';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    CommonModule,
    DragDropModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    TableContextMenuTriggerDirective,
  ],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.sass'],
})
export class TableComponent
  implements OnInit, OnDestroy, AfterViewInit, AfterContentInit
{
  /**
   * The possible inputs
   */
  @Input() scrollSize: number = undefined;
  @Input() itemSize = 80;
  @Input() withCard = false;
  @Input() titleFilter: string = undefined;
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() showFooter = false;
  @Input() cardTitle = '';
  @Input() dateFilter = false;
  @Input() showDownloadBtn = false;

  private _idList = '';
  public get idList(): string {
    return this._idList;
  }

  public set idList(value: string) {
    this._idList = value;
  }

  @Input() injectionToken: InjectionToken<TableService<any>> = undefined;

  protected _columns: string[] = [];
  get columns(): string[] {
    return [...this._columns];
  }

  @Input() set columns(value: string[]) {
    this.service.displayedColumns = value;
  }

  subscription: Subscription;
  sizePagination$ = this.service.sizePagination$;

  /**
   * All template/components about the tables
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<any>;
  @ContentChildren(MatHeaderRowDef) headerRowDefs: QueryList<MatHeaderRowDef>;
  @ContentChildren(MatRowDef) rowDefs: QueryList<MatRowDef<any>>;
  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  @ContentChild(TableMenuDirective)
  menuOptions?: TableMenuDirective;

  get form(): FormGroup {
    return this.service.form;
  }

  get dataSource$(): Observable<MatTableDataSource<any>> {
    return this.service.dataSource$;
  }

  constructor(protected service: TableService<any>) {}

  ngOnInit(): void {
    // if (this.injectionToken) {
    //   this.service = Inject(this.injectionToken);
    // }
    this.subscription = this.service.displayedColumns$.subscribe((columns) => {
      this._columns = columns;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.service.displayedColumns = [];
    this.service.isAfterViewInit = false;
  }

  ngAfterViewInit(): void {
    this.paginator._intl.itemsPerPageLabel = 'Items por pagina';
    this.service.paginator = this.paginator;
    this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
    this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef));
    this.headerRowDefs.forEach((headerRowDef) =>
      this.table.addHeaderRowDef(headerRowDef)
    );
    setTimeout(() => (this.service.isAfterViewInit = true), 50);
  }

  ngAfterContentInit(): void {
    // this.service.isAfterViewInit = true;
    /**
     * We do this in order to being able to see the rows/columns added by the parent component
     */
  }

  onTableSort(sort: Sort): void {
    this.service.sort(sort);
  }

  filtrarPorFecha(fecha: Date): void {
    this.service.dateFilter = fecha;
  }

  download(): void {
    this.service.download();
  }
}
